import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "src/app/services/app.service";
import { AlertController } from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { _getStorage } from "src/app/utils/local-storage";
import { STORAGE } from "src/app/constant/storages";

@Component({
  selector: "app-manual-config",
  templateUrl: "./manual-config.page.html",
  styleUrls: ["./manual-config.page.scss"],
})
export class ManualConfigPage implements OnInit {
  @Input() public activeconfig: any;
  version_string: any = this.appService.versionString;

  public appPages = [
    {
      title: "Customer Data",
      url: "/customer-search",
      icon: "mail",
      action: 1,
      isActive: false,
    },
    {
      title: "Seller Data",
      url: "/seller-data",
      icon: "paper-plane",
      action: 2,
      isActive: false,
    },
    {
      title: "Configuration",
      url: "/configuration-data",
      icon: "heart",
      action: 3,
      isActive: false,
    },
    {
      title: "Role Management",
      url: "/role-management-data",
      icon: "archive",
      action: 4,
      isActive: false,
    },
  ];

  versions: any;
  isCount = true;
  userRole: any;
  Active = "";
  constructor(
    public alertController: AlertController,
    public appService: AppService,
    public app: AppService,
    public router: Router,
    public storage: Storage
  ) {
    // this.appService.setActive(1);
    this.appPages = this.appService.mappingConfigRoleManagement(this.appPages);
    this.userRole = _getStorage(STORAGE.userRole);
    console.log("config rolemanagement...", this.appPages);
    let active = _getStorage("ActiveConfig");

    console.log("ActiveConfig.... =", active);

    if (this.activeconfig === 1) {
      if (this.appPages[0].isActive === active) {
        this.activeconfig = 1;
        this.router.navigate(["/customer-search"]);
      }
    }
    if (this.activeconfig === 2) {
      if (this.appPages[1].isActive === active) {
        this.activeconfig = 2;
        this.router.navigate(["/seller-data"]);
      }
    }
    if (this.activeconfig === 3) {
      if (this.appPages[2].isActive === active) {
        this.activeconfig = 3;
        this.router.navigate(["/configuration-data"]);
      }
    }
    if (this.activeconfig === 4) {
      if (this.appPages[3].isActive === active) {
        this.activeconfig = 4;
        this.router.navigate(["/role-management-data"]);
      }
    }

    console.log("this.activeconfig......", this.activeconfig);
    this.storage.remove("ActiveConfig");
  }

  ngOnInit() {}

  clickMenu(a) {
    this.storage.remove("ActiveConfig");
    this.activeconfig = a;
  }
}
